import { Heading, Text } from 'ui-kit/typography'
import clsx from 'clsx'
import classes from './ScenariosHero.module.scss'

export const ScenariosHero = ({ className }: { className: string }) => {
  return (
    <section className={clsx(classes.section, className)}>
      <Heading as={'h1'} size={'xxl'} center balance>
        Integration Scenarios
      </Heading>
      <Text size={'lg'} center balance className={classes.subtitle}>
        Add pre-built, battle-tested integration scenarios to your app, then
        customize them to your needs.
      </Text>
    </section>
  )
}
